import { BarChart3, Database, MessageCircle, Shield, TrendingUp } from "lucide-react";

const CRITERIA = [
  {
    name: "Research Integrity",
    icon: Database,
    desc: "Sourcing quality: primary vs secondary evidence, credibility and recency of references.",
  },
  {
    name: "Analytical Reasoning",
    icon: BarChart3,
    desc: "Argument structure, evidence weighting, and scenario reasoning.",
  },
  {
    name: "Relevance & Investment Impact",
    icon: TrendingUp,
    desc: "Whether your findings matter: materiality, actionability, and investor relevance.",
  },
  {
    name: "Clarity & Communication",
    icon: MessageCircle,
    desc: "Structure, concision, and professional presentation of your writing.",
  },
  {
    name: "Professional & Ethical Standards",
    icon: Shield,
    desc: "Professional conduct: balance, disclosure of AI use, and a compliance-aware mindset.",
  },
];

/** The five assessment criteria, each weighted equally. Shared by the guide pages. */
export function AssessmentCriteria() {
  return (
    <div className="mt-3.5 flex flex-col">
      {CRITERIA.map((c) => {
        const Icon = c.icon;
        return (
          <div
            key={c.name}
            className="flex items-center gap-4 border-b border-content-border/60 px-1 py-[15px]"
          >
            <div className="flex h-10 w-10 flex-none items-center justify-center rounded-[10px] bg-[#E9F1E6]">
              <Icon className="h-[19px] w-[19px] text-[#1E6F4F]" strokeWidth={1.6} />
            </div>
            <div className="min-w-0">
              <div className="text-[14.5px] font-bold text-card-foreground">{c.name}</div>
              <div className="mt-0.5 text-[13px] leading-[1.55] text-[#5C6E63]">{c.desc}</div>
            </div>
            <span className="ml-auto flex-none rounded-full border border-[#CBE3D2] bg-[#F0F8F2] px-3 py-1 text-xs font-bold text-[#1E6F4F]">
              20%
            </span>
          </div>
        );
      })}
    </div>
  );
}
